/* eslint-disable no-useless-escape */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'

import { MIXPANEL_EVENT, trackEvent } from '../../../../../../common/config'
import { VALIDATORS_CONFIG, TEST_DISABLED_ACTIVATION_ON_BACKEND } from '../../../../../../common/constants'
import {
    setFetchProcessSuccess,
    setBrandId,
    setModelId,
    setGenerationIdSelected,
    setGenerationSelected,
    setFuelTypesGroup,
    setGenerationObject,
    setFuelTypeIndex,
    setTankSize
} from '../../../../../../redux/actions'
import { activateDevice, getValidator } from '../../../common/operations'
import { ConfirmationList } from './confirmation-list'

const getPrefix = serialNumber => {
    if (serialNumber && typeof serialNumber === 'string' && serialNumber.length > 2) {
        return serialNumber.substring(0, 2)
    }

    return null
}

const isPresent = text => text && text.length > 0

const ConfirmationPage = ({ activeStep, intl, setPagerFunctions, setStep }) => {
    const dispatch = useDispatch()
    const customerNumber = useSelector(state => state.customerNumber.customerNumber)
    const contractNumber = useSelector(state => state.contractNumber.contractNumber)
    const choosedPropertyType = useSelector(state => state.choosedPropertyType.choosedPropertyType)
    const licensePlate = useSelector(state => state.licensePlate.licensePlate)
    const wfSubscription = useSelector(state => state.wfSubscription.wfSubscription)
    const deviceActivationKey = useSelector(state => state.deviceActivationKey.deviceActivationKey)
    const rmaDeviceSerialNumber = useSelector(state => state.rmaDeviceSerialNumber.rmaDeviceSerialNumber)
    const deviceSerialNumber = useSelector(state => state.deviceSerialNumber.deviceSerialNumber)
    const activationCode = useSelector(state => state.activationCode.activationCode)
    const generationSelected = useSelector(state => state.generationSelected.generationSelected)
    const generationIdSelected = useSelector(state => state.generationIdSelected.generationIdSelected)
    const generationRequired = useSelector(state => state.generationRequired.generationRequired)
    const tankSize = useSelector(state => state.tankSize.tankSize)

    const vehicleSpecification = generationIdSelected
        ? {
              generationId: generationIdSelected
          }
        : null

    const [errorMessage, setErrorMessage] = useState('')

    const isLink340Device = () => {
        const conf = VALIDATORS_CONFIG.step3

        return getValidator(
            conf.link340.enabled,
            conf.link340.prefix.includes(deviceSerialNumber.substring(0, 2)),
            false
        )
    }

    const onActivate = () => {
        const extractedVehicleType = isLink340Device() ? null : choosedPropertyType
        const extractedAssetType = isLink340Device() ? choosedPropertyType : null

        const body = {
            assetType: extractedAssetType,
            contracts: {
                number: contractNumber,
                tariff: wfSubscription
            },
            deviceActivationKey: deviceActivationKey.length > 0 ? deviceActivationKey.replace(/[\s\-]/g, '') : null,
            deviceSerialNumber: deviceSerialNumber,
            generationNumber: generationRequired && generationSelected !== 0 ? generationSelected : null,
            licensePlate: licensePlate,
            rmaDeviceSerialNumber: rmaDeviceSerialNumber,
            tankSize: tankSize === '' ? null : tankSize,
            vehicleType: extractedVehicleType === '' ? null : extractedVehicleType,
            vehicleSpecification
        }

        dispatch(setFetchProcessSuccess(false))

        if (!TEST_DISABLED_ACTIVATION_ON_BACKEND) {
            const getPreactivationTrackingProperties = mixpanelEvent => ({
                [mixpanelEvent.property.SERIAL_PREFIX]: getPrefix(deviceSerialNumber),
                [mixpanelEvent.property.RMA_SERIAL_PREFIX]: getPrefix(rmaDeviceSerialNumber),
                [mixpanelEvent.property.LICENSE_PLATE_PRESENT]: isPresent(licensePlate) ? 'PRESENT' : 'NOT_PRESENT',
                [mixpanelEvent.property.GENERATION_SELECTED]: generationSelected !== 0 ? 'SELECTED' : 'NOT_SELECTED'
            })

            activateDevice(activationCode, customerNumber, body)
                .then(() => {
                    dispatch(setFetchProcessSuccess(true))
                    dispatch(setBrandId(0))
                    dispatch(setModelId(0))
                    dispatch(setFuelTypeIndex(-1))
                    dispatch(setFuelTypesGroup([]))
                    dispatch(setGenerationSelected(0))
                    dispatch(setGenerationIdSelected(0))
                    dispatch(
                        setGenerationObject({
                            brand: '',
                            fuelType: '',
                            isFuelTypeShow: false,
                            model: '',
                            yearFrom: '',
                            yearTo: ''
                        })
                    )
                    dispatch(setTankSize(''))
                    setStep(activeStep + 1)
                    trackEvent(
                        MIXPANEL_EVENT.PREACTIVATION_SUCCESS.event,
                        getPreactivationTrackingProperties(MIXPANEL_EVENT.PREACTIVATION_SUCCESS)
                    )
                })
                .catch(() => {
                    dispatch(setFetchProcessSuccess(true))
                    setErrorMessage(intl.translate('ap_step4_error'))
                    trackEvent(
                        MIXPANEL_EVENT.PREACTIVATION_FAILURE.event,
                        getPreactivationTrackingProperties(MIXPANEL_EVENT.PREACTIVATION_FAILURE)
                    )
                })
        } else {
            dispatch(setFetchProcessSuccess(true))
            setStep(activeStep + 1)
        }
    }

    useEffect(() => {
        setPagerFunctions({
            onActivate: () => onActivate(),
            onBack: () => setStep(activeStep - 1),
            validator: true
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <ConfirmationList {...{ errorMessage, intl }} />
}

ConfirmationPage.propTypes = {
    activeStep: PropTypes.number,
    errorMessage: PropTypes.string,
    intl: PropTypes.objectOf(PropTypes.func),
    setPagerFunctions: PropTypes.func,
    setStep: PropTypes.func
}

export { ConfirmationPage }
